
<template>
    <div>
        <div style="text-align: center">
            <el-row>
                <el-popover placement="right" trigger="hover" width="8rem">
                    <el-button-group style="float: center">
                        <el-button
                            type="text"
                            style="margin-right: 0.6rem; font-size: 1rem"
                            @click="sendBaseLayer('map')"
                            >地图</el-button
                        >
                        <el-button
                            type="text"
                            style="margin-right: 0.6rem; font-size: 1rem"
                            @click="sendBaseLayer('image')"
                            >影像</el-button
                        >
                        <el-button
                            type="text"
                            style="font-size: 1rem"
                            @click="sendBaseLayer('terrain')"
                            >地形</el-button
                        >
                    </el-button-group>
                    <el-button
                        class="font_family icon-icon-ditu"
                        slot="reference"
                        style="
                            font-size: 2rem;
                            background-color: #fff;
                            padding: 3px;
                        "
                    ></el-button>
                </el-popover>
            </el-row>
            <el-row>
                <el-button
                    class="font_family icon-icon-kongjiansuyuanfenxi"
                    style="
                        font-size: 2rem;
                        background-color: #fff;
                        padding: 3px;
                    "
                    @click="layerControlDialog()"
                ></el-button>
            </el-row>
            <el-row>
                <el-button
                    class="font_family icon-icon-danxuankuang-xuanzhongtai"
                    style="
                        font-size: 2rem;
                        background-color: #fff;
                        padding: 3px;
                    "
                    @click="displayLgend()"
                >
                </el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {
        sendBaseLayer(value) {
            this.$emit('sendBaseLayer', value)
        },
        layerControlDialog() {
            this.$emit('layerControlDialog')
        },
        displayLgend() {
            this.$emit('displayLgend')
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/V3/Main/Home/comToolBox.vue